module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACYSURBVEhL7Y6xDcIwFERdZouIlg2YJQVKwRg0iCpzRKnCKmkYh0jh3u8QthNDyv+kV5x89+XgOM4Hy85+ESv9Y5RJ8niyVAYbttxIMkpKjaUy2LDlRpJOUrpaKoMNW24kuUhKD0tlsGHLjSQH+ZKzPMtKrkGnlWzY1jLLXfKTX7zJTQwydiBnLzfzlIyOlvLQocvGcXYnhDeSWV1LZSNEJwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-bath/dark/24.png
// module id = 1870
// module chunks = 2